export default "__VITE_ASSET__CDWxjutC__"